import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import { FormattedMessage } from 'react-intl';
import Grid from '@material-ui/core/Grid';
import UserHeader from '../../organisms/UserHeader';
import { connect } from 'react-redux';
import { workOperations } from './../../../reducks/work';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 4px 15px 4px',
    backgroundColor: '#fafafa',
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto', 
  },
  root2: {
    flexDirection: 'column',
    textAlign: "center",
  },
  typography:{
    margin: '10px 0 0 20px',
    textAlign: "left"
  },
  paper: {
    marginTop: '0px',
    marginLeft: '16px',
    marginRight: '16px',
  },
  button: {
    margin: '20px 0 20px 0',
    padding:"8px",
    width: '60%',
    minWidth: '250px',
    primary: {
      light: '#000000',
      main: '#000000',
      dark: '#82b3c9',
      contrastText: '#000000',
    },
  },
  cellHeight: {
    height: '15px',
  }
});

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: "#dddddd",
    color: "#006666",
    fontSize: 14,
  },
  root: {
    padding: '4px 3px 4px 3px !important',
    textAlign: 'center',
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: "#f5f8f5",
    },
    '&:nth-of-type(even)': {
      backgroundColor: "#ffffff",
    },
  },
}))(TableRow);

class WorkMenu extends React.Component {
  state = {
    comment: '',
  };

  nodata = {
    padding: '10px 10px 10px 5px !important',
  };

onClickProtectivePipeNew = () => {
  this.props.history.push('/workImportantMatter');
};

onClickServiceLineNew = () => {
  this.props.history.push('/workImportantMatterSeparation');
};

onClickConsider = (Id, Status__c, FreeOfChargeFlag__c, OrderCategory__c) => {
  console.log("#WorkConsideration表示#");
  const param = {
    Id, Status__c
  };
  console.log(param);
  this.props.selectApply(param); // 対象のIdとステータスを設定

  if (OrderCategory__c == '防護管取付') {
    if (FreeOfChargeFlag__c) {
      // 無償
      this.props.history.push('/workConsideration');
    } else {
      this.props.history.push('/workConsiderationPay');
    }
  } else {
    this.props.history.push('/workConsiderationSeparation');
  }
};

// ログイン画面に遷移
doMoveLogin = () => {
  this.props.history.push("/login");
};


  render() {
    const { classes, applyList } = this.props;

    let workData = [];
    console.log(applyList);
    if (applyList) {
      if (applyList.errorCode === '00000') {
         if (applyList.data) {
           workData = applyList.data;
        }
      } else {
        // エラーだった場合の処理
        const { doOpenDialog } = this.props;
        const dialog = {
           type: 'error', // '閉じる'のみ表示
           title: 'system.message.error.title',
           message: 'system.message.error.context',
        };
        doOpenDialog(dialog);
      }
    }

    return (
      <div className={classes.root}>
      <UserHeader />
      <Grid item xs={12} className={classes.root2}>
        <div className={classes.root2}>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          size="large"
          onClick={this.onClickProtectivePipeNew}
        >
         <span><FormattedMessage id={'workmenu.btn.protectivepipe.new'}/></span>
        </Button>
        </div>
        <div className={classes.root3}>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          size="large"
          onClick={this.onClickServiceLineNew}
        >
         <span><FormattedMessage id={'workmenu.btn.serviceline.new'}/></span>
        </Button>
        </div>
        </Grid>

        <Typography variant="h6" className={classes.typography}><span><FormattedMessage id={'workmenu.title.list'}/></span></Typography>
          <Paper className={classes.paper}>
           {workData.length > 0 ?
            <Table>
              <TableHead>
                <TableRow style={{height: 16, whiteSpace: 'nowrap'}}>
                  <StyledTableCell style={{width: '16%'}}><span><FormattedMessage id={'workmenu.title.number'}/></span></StyledTableCell>
                  <StyledTableCell style={{width: '50%'}}><span><FormattedMessage id={'workmenu.title.subject'}/></span></StyledTableCell>
                  <StyledTableCell style={{width: '15%'}}><span><FormattedMessage id={'workmenu.title.classification'}/></span></StyledTableCell>
                  <StyledTableCell style={{width: '19%'}}><span><FormattedMessage id={'workmenu.title.status'}/></span></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {workData.map(row => (
                  <StyledTableRow
                    key={row.Id}
                    className={classes.cellHeight}
                    >
                    <StyledTableCell
                      onClick={()=>{this.onClickConsider(row.Id, row.Status__c, row.FreeOfChargeFlag__c, row.OrderCategory__c)}}
                      component="th"
                      scope="row"
                      style={{whiteSpace: 'nowrap', width:"200px", cursor: 'pointer'}}
                     >
                      <u style={{color:'#0000ff', cursor:'hand'}}>{row.OrderNumber__c}</u>
                    </StyledTableCell>
                    <StyledTableCell style={{width: "50%", textAlign: "left"}}>
                      <Tooltip title={row.OrderName__c} placement="top">
                      <div style={{overflow:"hidden", height:16, width:"100%"}}>
                        {row.OrderName__c}
                      </div>
                    </Tooltip>
                    </StyledTableCell>
                    <StyledTableCell style={{whiteSpace: 'nowrap', width: "20%"}}>{row.OrderCategory__c}</StyledTableCell>
                    <StyledTableCell style={{whiteSpace: 'nowrap', width: "20%"}}>{row.StatusOperator__c}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
            :
            <div style={{margin: "10px 0 10px 0", textAlign: "center"}}>
            <FormattedMessage className={classes.typography} id={'message.info.nodata'} />
            </div>
          }
        </Paper>
      </div>
    );
  }
}

WorkMenu.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  selectApply: workOperations.selectApply,
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
    )(WorkMenu));